import { render, staticRenderFns } from "./ViewCustomerOrder.vue?vue&type=template&id=2a716834&scoped=true&"
import script from "./ViewCustomerOrder.vue?vue&type=script&lang=js&"
export * from "./ViewCustomerOrder.vue?vue&type=script&lang=js&"
import style0 from "./ViewCustomerOrder.vue?vue&type=style&index=0&id=2a716834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a716834",
  null
  
)

export default component.exports